import {
  Sun,
  Moon,
  MoonStar,
  Leaf,
  Flower,
  Flower2,
  Waves,
  Wind,
  Feather,
  Sparkles,
  CircleDot,
  Infinity as InfinityIcon,
  Droplet,
  Mountain,
  Flame,
  Snowflake,
  Heart,
  HeartHandshake,
  Sunrise,
  Sunset,
  TreePine,
  Compass,
  Sprout,
  Orbit,
} from "lucide-react";
import { DefaultIcon } from "@/components/DefaultIcons";
import { absoluteUrl } from "@/lib/api";

export const ZEN_ICONS = {
  Sun,
  Moon,
  MoonStar,
  Leaf,
  Flower,
  Flower2,
  Waves,
  Wind,
  Feather,
  Sparkles,
  CircleDot,
  Infinity: InfinityIcon,
  Droplet,
  Mountain,
  Flame,
  Snowflake,
  Heart,
  HeartHandshake,
  Sunrise,
  Sunset,
  TreePine,
  Compass,
  Sprout,
  Orbit,
};

export function renderModalityIcon(value, index) {
  if (!value) return <DefaultIcon index={index} />;
  if (value.startsWith("lucide:")) {
    const Icon = ZEN_ICONS[value.slice(7)];
    if (Icon) return <Icon strokeWidth={1.6} />;
  }
  return <img src={absoluteUrl(value)} alt="" />;
}
